import { formatMoney } from './toSaveRows';
import { groupByMeter, isMeterUnpriced, num, toCents } from './splitRowDisplay';
import { splitCentsKeepingOwnerDays } from './ownerDaysPreview';
const meterCentsOf = row => toCents(num(row.baseCharge) + num(row.usageCharge));
const rowsCentsOf = group => group.reduce((sum, row) => sum + toCents(row.allocationCharge), 0);
const sharesOneMeterTotal = group => group.every(row => meterCentsOf(row) === meterCentsOf(group[0]));
const formatDollars = cents => formatMoney(cents / 100);
export const toBalancedMeterKeys = rows => {
  const keys = new Set();
  groupByMeter(rows).forEach((group, key) => {
    if (group.length > 1 && sharesOneMeterTotal(group) && rowsCentsOf(group) === meterCentsOf(group[0])) keys.add(key);
  });
  return keys;
};

// Whether every row holds exactly its own share once the owner keeps the days of the period no row covers,
// as an edit previews it. Never judged on the rows' sum: a typed charge can land on the same sum.
const isEveryRowOwnerShare = (group, meterCents, periodDays) => {
  const shares = splitCentsKeepingOwnerDays(meterCents, group.map(row => num(row.serviceDaysInPeriod)), periodDays);
  return !!shares && group.every((row, idx) => toCents(row.allocationCharge) === shares[idx]);
};
export const toMeterTotalMismatches = (rows, balancedKeys, periodDays) => {
  const mismatches = [];
  groupByMeter(rows).forEach((group, key) => {
    if (!balancedKeys.has(key) || !sharesOneMeterTotal(group) || isMeterUnpriced(group)) return;
    const meterCents = meterCentsOf(group[0]);
    const rowsCents = rowsCentsOf(group);
    if (rowsCents === meterCents || isEveryRowOwnerShare(group, meterCents, periodDays)) return;
    const _group$ = group[0],
      unitName = _group$.unitName,
      meterSerialNumber = _group$.meterSerialNumber;
    const difference = "".concat(formatDollars(Math.abs(rowsCents - meterCents)), " ").concat(rowsCents > meterCents ? 'more' : 'less');
    const meter = meterSerialNumber ? "Unit ".concat(unitName, ", meter ").concat(meterSerialNumber) : "Unit ".concat(unitName);
    mismatches.push({
      key,
      message: "".concat(meter, ": the rows add up to ").concat(formatDollars(rowsCents), ", ").concat(difference, " than the meter total of ").concat(formatDollars(meterCents), ".")
    });
  });
  return mismatches;
};